function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ActionIconName, Icon } from '../../Icons';
import { CollapseTools } from './CollapseTools';
import { MessageBar } from '../../MessageBar';
import { MessageBarType, Stack } from 'office-ui-fabric-react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const TableHeader = props => {
  const findColumnById = (columns, id, currentDepth) => {
    if (!columns) {
      return {
        column: undefined,
        depth: []
      };
    }
    let depth = currentDepth || [];
    let foundColumn = undefined;
    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      if (column.id === id) {
        foundColumn = column;
        depth = [...depth, i];
        break;
      }
      foundColumn = findColumnById(column.columns, id, [...depth, i]).column;
      if (foundColumn) {
        depth = findColumnById(column.columns, id, [...depth, i]).depth;
        break;
      }
    }
    return {
      column: foundColumn,
      depth
    };
  };
  const changeCollapsing = id => {
    const foundColumn = findColumnById(props.tableColumns, id);
    if (!foundColumn.column || !foundColumn.depth.length) {
      return;
    }
    const depth = foundColumn.depth;
    const newColumns = [...props.tableColumns];
    let referenceToNestedColumn = newColumns[depth[0]];
    for (let i = 1; i < depth.length; i++) {
      referenceToNestedColumn = referenceToNestedColumn.columns[depth[i]];
    }
    referenceToNestedColumn.isExpanded = !referenceToNestedColumn.isExpanded;
    if (foundColumn.column.onExpandChange) {
      foundColumn.column.onExpandChange(id, referenceToNestedColumn.isExpanded);
    }
    props.changeTableColumns(newColumns);
  };
  const renderSortingTools = column => {
    const buttonStyle = {
      zIndex: 2,
      cursor: 'pointer',
      paddingRight: 5
    };
    return /*#__PURE__*/_jsx(_Fragment, {
      children: column.sortDescending === props.sortBy ? /*#__PURE__*/_jsx(Icon, {
        iconName: ActionIconName.SortDesc,
        styles: {
          root: buttonStyle
        },
        onClick: () => props.onSortChange(column.sortAscending)
      }) : column.sortAscending === props.sortBy ? /*#__PURE__*/_jsx(Icon, {
        iconName: ActionIconName.SortAsc,
        styles: {
          root: buttonStyle
        },
        onClick: () => props.onSortChange('')
      }) : column.sortAscending !== props.sortBy ? /*#__PURE__*/_jsx(Icon, {
        iconName: ActionIconName.Sort,
        styles: {
          root: _objectSpread(_objectSpread({}, buttonStyle), {}, {
            opacity: column.isSorted ? 1 : 0.25
          })
        },
        onClick: () => props.onSortChange(column.sortDescending)
      }) : null
    });
  };
  const checkIsHeaderRowEmpty = headerGroup => {
    let isHeaderRowEmpty = true;
    headerGroup.headers.forEach(headerCell => {
      var _headerCell$Header, _headerCell$Header2;
      if (((_headerCell$Header = headerCell.Header) === null || _headerCell$Header === void 0 ? void 0 : _headerCell$Header.toString().trim()) == '' || (_headerCell$Header2 = headerCell.Header) !== null && _headerCell$Header2 !== void 0 && _headerCell$Header2.toString().startsWith('function')) {
        return;
      }
      isHeaderRowEmpty = false;
    });
    return isHeaderRowEmpty;
  };
  return /*#__PURE__*/_jsx("div", {
    className: "header",
    ref: props.componentRef,
    children: props.headerGroups.map(headerGroup => {
      const isHeaderRowEmpty = checkIsHeaderRowEmpty(headerGroup);
      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
        className: "tr",
        style: {
          display: isHeaderRowEmpty ? 'none' : 'flex'
        },
        children: headerGroup.headers.map(column => {
          const isNoDataMessageVisible = column.filterValue && !props.hasData && !props.isDataLoading;
          return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, column.getHeaderProps()), {}, {
            className: 'th',
            children: [/*#__PURE__*/_jsxs("div", {
              className: 'th__content',
              children: [column.isFilterVisible ? /*#__PURE__*/_jsxs(Stack, {
                horizontal: true,
                verticalAlign: "center",
                maxWidth: column.width,
                children: [column.render('Header'), /*#__PURE__*/_jsxs(Stack, {
                  styles: {
                    root: {
                      marginLeft: 5
                    }
                  },
                  children: [column.render('Filter'), /*#__PURE__*/_jsx("div", {
                    children: isNoDataMessageVisible && /*#__PURE__*/_jsx(MessageBar, {
                      messageBarType: MessageBarType.info,
                      "data-id": 'title-not-found-error',
                      children: "No results found"
                    })
                  })]
                })]
              }) : /*#__PURE__*/_jsx("div", {
                className: "th__content--header",
                children: column.render('Header')
              }), (column.isSortable || column.isCollapsable) && /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, column.getHeaderProps()), {}, {
                className: "th__tools",
                children: [column.isSortable && (column.isCollapsable ? column.isExpanded ? true : false : true) && renderSortingTools(column), column.isCollapsable && /*#__PURE__*/_jsx(CollapseTools, {
                  column: column,
                  changeCollapsing: changeCollapsing,
                  customCollapseTool: column.customCollapseTool
                }, column.originalId)]
              }))]
            }), column.isResizeable && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, column.getResizerProps()), {}, {
              className: column.isCollapsable && !column.isExpanded ? 'th__separator collapsed' : 'th__separator',
              style: _objectSpread({}, column.getResizerProps().style)
            }))]
          }));
        })
      }));
    })
  });
};